import { SEG_VIEW } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  entity: {},
  fetchEntityStatus: null,
  editEntityStatus: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEG_VIEW.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case SEG_VIEW.FETCH_ENTITY:
      return {
        ...state,
        fetchEntityStatus: CONSTANTS.API.STARTED,
      };
    case SEG_VIEW.FETCH_ENTITY_SUCCEEDED:
      return {
        ...state,
        entity: action.payload,
        fetchEntityStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_VIEW.FETCH_ENTITY_FAILED:
      return {
        ...state,
        fetchEntityStatus: CONSTANTS.API.FAILED,
      };
    case SEG_VIEW.EDIT_ENTITY:
      return {
        ...state,
        editEntityStatus: CONSTANTS.API.STARTED,
      };
    case SEG_VIEW.EDIT_ENTITY_SUCCEEDED:
      return {
        ...state,
        entity: {
          ...state.entity,
          ...action.payload.payload,
        },
        editEntityStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_VIEW.EDIT_ENTITY_FAILED:
      return {
        ...state,
        editEntityStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
